import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { FolderOpen as FolderOpenIcon } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';

interface ParentDropZoneProps {
  parentContainer: any;
  onDrop: (itemId: string) => void;
  onClick?: () => void;
}

const ParentDropZone: React.FC<ParentDropZoneProps> = ({ parentContainer, onDrop, onClick }) => {
  const {
    attributes,
    setNodeRef,
    transition,
    isDragging,
    isOver,
  } = useSortable({
    id: 'parent-folder',
    data: { isParentZone: true }
  });

  const style = {
    // Pas de transformation pour éviter que la zone bouge
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Card
      ref={setNodeRef}
      style={style}
      {...attributes}
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        backgroundColor: isOver ? 'primary.light' : 'action.hover',
        position: 'relative',
        border: '2px dashed',
        borderColor: isOver ? 'primary.main' : 'grey.400',
        transform: isOver ? 'scale(1.02)' : 'scale(1)',
        transition: 'all 0.2s ease',
        boxShadow: isOver ? '0 4px 12px rgba(25, 118, 210, 0.25)' : 'none',
      }}
    >
      <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
        <Box display="flex" alignItems="center" gap={1}>
          <FolderOpenIcon sx={{
            color: isOver ? 'primary.main' : 'action.active',
            transition: 'color 0.2s ease'
          }} />
          <Typography
            variant="subtitle2"
            sx={{
              fontStyle: 'italic',
              color: isOver ? 'primary.main' : 'text.primary',
              fontWeight: isOver ? 600 : 400,
              transition: 'all 0.2s ease'
            }}
          >
            .. (Niveau parent{parentContainer ? `: ${parentContainer.title}` : ''})
          </Typography>
        </Box>
        <Typography
          variant="caption"
          sx={{
            color: isOver ? 'primary.main' : 'text.secondary',
            fontWeight: isOver ? 500 : 400,
            transition: 'all 0.2s ease'
          }}
        >
          {isOver ? '↑ Relâcher pour déplacer vers le niveau supérieur' : 'Déposez ici pour déplacer vers le niveau supérieur'}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ParentDropZone;